module.exports = __webpack_public_path__ + "img/card-tranzactie-procram.68542f2a.svg";